import dealer_config from "../data/dealer_config.json";
import axios from 'axios';
import PowerTrip from "../services/api/PowerTrip.js";
import _ from 'lodash';
import Vue from 'vue';
export default {

    carType: "Standard",
    user_settings: Object.assign({}, dealer_config.default_settings),
    default_settings: Object.assign({},dealer_config),
    username: "",
    password: "",
    serviceCode: "",
    carData: [],
    modelData: [],

    async init(serviceCode, vuetify) {
        if (serviceCode) {
            this.serviceCode = serviceCode;
        }

        if (localStorage.getItem("credentials")) {
            let split = localStorage.getItem("credentials").split("|@|!|");
            this.username = split[0];
            this.password = split[1];
        }
        if (this.serviceCode !== undefined) {

            let response = await axios.get("https://thepowertrip.co.nz/referral/service/" + this.serviceCode, {
                auth: {
                    username: this.username,
                    password: this.password
                }
            });
 
            _.merge(this.default_settings, response.data);
            //this.default_settings = { ...this.default_settings, ...response.data };
            this.user_settings = Object.assign({}, this.default_settings.default_settings);
            if (typeof this.default_settings.addressData == "string") {
                try {

                    this.default_settings.addressData = JSON.parse(this.default_settings.addressData);
                } catch(e) {
                    console.log("Invalid JSON");
                }
            }
            this.fixTheme();
            this.updateTheme(vuetify);

            this.carData = await this.loadCars();
            this.modelData = await PowerTrip.getEVModels();

            return this.default_settings;
        } else {
            this.modelData = await PowerTrip.getEVModels();

            return this.default_settings;           
        }


    },
    fixTheme() {
        if (this.default_settings.theme.primary == null) {
            this.default_settings.theme = {
                primary: '#1976D2',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
                anchor: '#1976D2'
            };
        }
    },
    save() {
        console.log("Saving");
        var clone = JSON.parse(JSON.stringify(this.default_settings));
        try {
        clone.contactAddress = clone.addressData.Address.Address;
        clone.latitude = clone.addressData.Address.geometry.coordinates[1];
        clone.longitude = clone.addressData.Address.geometry.coordinates[0];
        } catch (e) {
            console.log(e);
        }
        clone.addressData = JSON.stringify(clone.addressData);
        
        axios.post("https://thepowertrip.co.nz/referral/service/" + this.serviceCode, JSON.stringify(clone), {
            auth: {
                username: this.username,
                password: this.password
            }
        });
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Save Dealer Settings",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
    },
    saveCars(cars) {
                Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Save Dealer Cars",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        return axios.post("https://thepowertrip.co.nz/referral/cars/" + this.serviceCode, JSON.stringify(cars), {
            auth: {
                username: this.username,
                password: this.password
            }
        }).then(response => {
            return response.data
        });

    },
    loadCars() {
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Load Dealer Cars",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        return axios.get("https://thepowertrip.co.nz/referral/cars/" + this.serviceCode).then(response => {
            return response.data
        });

    },
    getReferrals() {
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Get Referrals",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        return axios.get("https://thepowertrip.co.nz/referral/referrals/" + this.serviceCode, {
            auth: {
                username: this.username,
                password: this.password
            }
        }).then(response => {
            return response.data
        });

    },
    myCrew() {
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Get Crew",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        return axios.get("https://thepowertrip.co.nz/referral/mycrew/" + this.serviceCode, {
            auth: {
                username: this.username,
                password: this.password
            }
        }).then(response => {
            return response.data
        });
    },
    enquiries() {
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Get Enquiries",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        return axios.get("https://thepowertrip.co.nz/referral/enquiries/" + this.serviceCode, {
            auth: {
                username: this.username,
                password: this.password
            }
        }).then(response => {
            return response.data
        });
    },
    sendUpdate(title, message, crew, points) {
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Send Update",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        const payload = { 'title': title, 'message': message, 'crew': crew, "awardPoints":points}
        return axios.post("https://thepowertrip.co.nz/referral/broadcastupdate/" + this.serviceCode, JSON.stringify(payload), {
            auth: {
                username: this.username,
                password: this.password
            }
        }).then(response => {
            return response.data
        });
    },
    assignPoints(code, referralPoints, referredPoints) {
        Vue.prototype.$Countly.q.push([
            "add_event",
            {
              key: "Assign Points",
              segmentation: {
                dealer: this.default_settings.name,
              },
            },
          ]);
        const payload = { 'contact': true, 'referrerPoints': referralPoints, 'referredPoints': referredPoints }
        return axios.post("https://thepowertrip.co.nz/referral/referrals/" + code, JSON.stringify(payload), {
            auth: {
                username: this.username,
                password: this.password
            }
        }).then(response => {
            return response.data
        });
    },
        createReminder(data) {
        return axios.post("https://thepowertrip.co.nz/referral/submitReminders",JSON.stringify([data]),{
            auth: {
                username: this.username,
                password: this.password
            }
        }).then(response => {
            return response.data
        });
    },
    async signup(serviceName, email, password) {
        this.username = email;
        this.password = password;
        var result = {};
        const payload = { 'title': serviceName, 'email': email, 'password': password }
        try {
            result = await axios.post("https://thepowertrip.co.nz/referral/servicesignup/", JSON.stringify(payload));
        } catch (e) {
            result.data = {}
            result.data.message = "failed";
        }
        return result.data;
    },
    async checklogin(username, password) {
        this.username = username;
        this.password = password;
        var result = {};
        try {

            result = await axios.get("https://thepowertrip.co.nz/referral/authcheck/" + this.serviceCode, {
                auth: {
                    username: this.username,
                    password: this.password
                }
            });
        } catch (e) {
            result.data = {}
            result.data.message = "failed";
        }
        return result.data.message == "success";
    },
    updateTheme($vuetify) {
        if (this.default_settings.theme && $vuetify.theme) {
            console.log($vuetify.theme);
            console.log(this.default_settings.theme);

            $vuetify.theme.dark = this.default_settings.theme.dark;

            $vuetify.theme.themes.dark.primary = this.default_settings.theme.primary;
            $vuetify.theme.themes.dark.secondary = this.default_settings.theme.secondary;
            $vuetify.theme.themes.dark.accent = this.default_settings.theme.accent;
            $vuetify.theme.themes.dark.anchor = this.default_settings.theme.anchor;

            $vuetify.theme.themes.light.primary = this.default_settings.theme.primary;
            $vuetify.theme.themes.light.secondary = this.default_settings.theme.secondary;
            $vuetify.theme.themes.light.accent = this.default_settings.theme.accent;
            $vuetify.theme.themes.light.anchor = this.default_settings.theme.anchor;
        }

    }
}